import React from 'react';
import NavLink from './NavLink.js';
import logo from './logo.png';
import closeIcon from '../common/close.png';
import styles from './Header.module.scss';
import {isMobileDevice} from '../utils/utils.js';

const links = [
  {
    container: 'home',
    title:'Home'
  },
  {
    container: 'collections',
    title:'Collections'
  },
  {
    container: 'about',
    title:'About Us'
  },
  {
    container: 'testimonials',
    title:'Testimonials'
  },
  {
    container: 'contact',
    title:'Contact Us'
  },
];

const styleHeader = {
  opacity: 1,
  visibility: 'visible',
  backgroundColor: '#3f3f3f'
};

const DesktopHeader = props => {
  return (
    <header
      className={styles.header}
      style={props.showOnMobile && isMobileDevice ? styleHeader : null}
    >
      <img
        className={styles.logo}
        src={logo}
        alt='site-logo'
      />
      <img
        className={styles.closeIcon}
        src={closeIcon}
        alt='close-icon'
        onClick={() => props.handleClick()}
      />
      {links.map(link => {
        return (
          <NavLink
            {...link}
            key={link.container}
            handleClick={props.handleClick}
          />
        );
      })}
    </header>
  );
}

export default DesktopHeader;